module.exports = __webpack_public_path__ + "static/media/bulb-good-lift.10568588.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Bulbs/bulb-good-lift.svg
// module id = 1589
// module chunks = 0